/* eslint-disable @typescript-eslint/consistent-type-imports */
import { getAPI, type UserAPI } from '@sydle/ui-api';
import { type UIAppConfig } from '@sydle/ui-app';
import { getConfig, Provider } from '@sydle/ui-utils';
import type { ActionResult, Context } from '@vaadin/router';
import { refreshHead, setLinkTags } from '../utils/utils';

export async function fetchGetPost(context: Context): Promise<ActionResult> {
  const provider = new Provider(document.documentElement);
  if (!context.params['postIdentifier'] && !context.params['draftId']) {
    provider?.update?.('postBody', null);
    return;
  }

  const draftId = context.params['draftId'];
  const postIdentifier = context.params['postIdentifier']?.toString();
  const postId = context.params['postId']?.toString();

  const body = {
    postIdentifier,
    postId,
  };

  if (draftId) {
    const url = new URL(window.location.href);

    const lang = url.searchParams.get('lang');
    if (lang) {
      getAPI<UserAPI>('userAPI')?.setCurrentLanguage(lang);
    }
    body['isDraft'] = true;
    body.postId = draftId.toString();
  }

  if (
    (postId && postId === (provider.provides?.['postBody'] as any)?._id) ||
    (postIdentifier && postIdentifier === (provider.provides?.['postBody'] as any)?.identifier)
  ) {
    return;
  }

  provider.update?.('postBody', null);

  if ((window as any).preloadPost) {
    const post = (window as any).preloadPost.body;
    const encodeScript = encodeURIComponent('</script>');
    if (post.preview) {
      post.preview = post.preview.replaceAll(encodeScript, '</script>');
    }
    if (post.content) {
      post.content = post.content.replaceAll(encodeScript, '</script>');
    }
    const node = document.getElementById('preloadPost');
    if (node?.parentNode) {
      node.parentNode.removeChild(node);
    }
    provider?.update?.('postBody', post);
    delete (window as any).preloadPost;
  } else {
    window.blogFacade?.getPost(body, body['isDraft']).then((response) => {
      if (response.error) {
        console.error(response.error);
      }
      provider?.update?.('postBody', response.data?.body);
      const route = getConfig<UIAppConfig>('ui-app')?.routes.find((route) => route.name === 'post');
      const titleTemplate = (route?.dynamicTitle ? route?.titleTemplate : route?.title) || '';
      const title = response.data?.body?.title || '';

      refreshHead(response.data, titleTemplate, title, false);
      setLinkTags(response.data?.body?.urls || []);
    });
  }
}
